"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = exports.palette = exports.mediaQueries = exports.fontFamily = exports.control = exports.borderWidth = exports.borderRadius = void 0;
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */
/** The values for these CSS variables are defined in [styles/borderRadius](./styles/borderRadius.ts) */
const borderRadius = {
  roundedNone: 'var(--border-radius-rounded-none)',
  roundedSmall: 'var(--border-radius-rounded-small)',
  rounded: 'var(--border-radius-rounded)',
  roundedMedium: 'var(--border-radius-rounded-medium)',
  roundedLarge: 'var(--border-radius-rounded-large)',
  roundedXLarge: 'var(--border-radius-rounded-x-large)',
  roundedFull: 'var(--border-radius-rounded-full)'
};

/** The values for these CSS variables are defined in [styles/borderWidth](./styles/borderWidth.ts) */
exports.borderRadius = borderRadius;
const borderWidth = {
  none: 'var(--border-width-none)',
  button: 'var(--border-width-button)',
  card: 'var(--border-width-card)',
  checkbox: 'var(--border-width-checkbox)',
  radio: 'var(--border-width-radio)',
  sparkline: 'var(--border-width-sparkline)',
  focusRing: 'var(--border-width-focus-ring)',
  input: 'var(--border-width-input)'
};
exports.borderWidth = borderWidth;
const spacing = {
  '0': 'var(--spacing-0)',
  '1': 'var(--spacing-1)',
  '2': 'var(--spacing-2)',
  '3': 'var(--spacing-3)',
  '4': 'var(--spacing-4)',
  '5': 'var(--spacing-5)',
  '6': 'var(--spacing-6)',
  '7': 'var(--spacing-7)',
  '8': 'var(--spacing-8)',
  '9': 'var(--spacing-9)',
  '10': 'var(--spacing-10)',
  '0.5': 'var(--spacing-0\\.5)',
  '1.5': 'var(--spacing-1\\.5)'
};
exports.spacing = spacing;
const palette = {
  foreground: 'var(--foreground)',
  foregroundMuted: 'var(--foreground-muted)',
  background: 'var(--background)',
  backgroundAlternate: 'var(--background-alternate)',
  backgroundOverlay: 'var(--background-overlay)',
  line: 'var(--line)',
  lineHeavy: 'var(--line-heavy)',
  primary: 'var(--primary)',
  primaryWash: 'var(--primary-wash)',
  primaryForeground: 'var(--primary-foreground)',
  negative: 'var(--negative)',
  negativeForeground: 'var(--negative-foreground)',
  positive: 'var(--positive)',
  positiveForeground: 'var(--positive-foreground)',
  secondary: 'var(--secondary)',
  secondaryForeground: 'var(--secondary-foreground)',
  transparent: 'var(--transparent)',
  warning: 'var(--warning)'
};
exports.palette = palette;
const control = {
  checkboxSize: 'var(--checkbox-size)',
  radioSize: 'var(--radio-size)',
  switchWidth: 'var(--switch-width)',
  switchHeight: 'var(--switch-height)',
  switchThumbSize: 'var(--switch-thumb-size)'
};
exports.control = control;
const fontFamily = {
  display: 'var(--cds-font-display)',
  sans: 'var(--cds-font-sans)',
  text: 'var(--cds-font-text)',
  mono: 'var(--cds-font-mono)'
};
exports.fontFamily = fontFamily;
const mediaQueries = {
  supportsHover: '@media (any-hover: hover)'
};
exports.mediaQueries = mediaQueries;